import script from "./ProductsFavoritePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsFavoritePage.vue?vue&type=script&setup=true&lang=js"

import "./ProductsFavoritePage.vue?vue&type=style&index=0&id=044820b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044820b2"]])

export default __exports__